import { parseRem } from './utils'
export const BORDER = {
  // Radius
  radius: {
    /** @property {string} 0px */
    none: parseRem(0),
    /** @property {string} 4px */
    xs: parseRem(4),
    /** @property {string} 8px */
    sm: parseRem(8),
    /** @property {string} 12px */
    md: parseRem(12),
    /** @property {string} 16px */
    lg: parseRem(16),
    /** @property {string} > 500px */
    pill: parseRem(500),
    /** @property {string} 50% */
    circular: '50%'
  },

  // Width
  width: {
    none: 0,
    hairline: parseRem(1),
    thin: parseRem(2),
    thick: parseRem(3),
    heavy: parseRem(5)
  }
}
